import { ScheduledNotification } from './scheduled-notification.model';

export class ScheduledNotificationSearchResult {
  notifications: ScheduledNotification[];
  totalNotifications: number;
}
